import { render, staticRenderFns } from "./loading-indicator.vue?vue&type=template&id=b06cef74"
import script from "./loading-indicator.vue?vue&type=script&lang=ts"
export * from "./loading-indicator.vue?vue&type=script&lang=ts"
import style0 from "./loading-indicator.vue?vue&type=style&index=0&id=b06cef74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports